import React from 'react';

import cn from 'classnames';

import { Table } from '@shared/components/bootstrap';
import { Currency } from '@shared/components/helpers';

import { SelectedCheck } from '@admin/components/orders/show/selected_check';
import { DoorToDoor__BundleEnum } from '@admin/schema';

const PACKING_HELP_TAG = 'Packing Help';

const PACKAGE_LABELS: Record<DoorToDoor__BundleEnum, string> = {
  [DoorToDoor__BundleEnum.Basic]: 'Basic',
  [DoorToDoor__BundleEnum.PickupAndPacking]: 'Pickup & Packing',
};

type PackageOption = {
  kind: DoorToDoor__BundleEnum;
  packageSetEntry?: { fixedCost: number } | null;
};

export const PackingPackagesTable: React.FC<{
  options: PackageOption[];
  tags: string[];
}> = ({ options, tags }) => {
  if (options.length < 2) {
    return null;
  }

  const currentKind = tags.includes(PACKING_HELP_TAG)
    ? DoorToDoor__BundleEnum.PickupAndPacking
    : DoorToDoor__BundleEnum.Basic;

  return (
    <>
      <p>
        <strong>Service packages:</strong>
      </p>
      <Table striped>
        <thead>
          <tr>
            <th className="text-left col-sm-2">Package</th>
            <th className="text-left col-sm-2">Price</th>
          </tr>
        </thead>
        <tbody>
          {options.map((option) => (
            <tr key={option.kind} className={cn({ info: option.kind === currentKind })}>
              <td className="text-left col-sm-2">
                {PACKAGE_LABELS[option.kind] ?? option.kind}
                <SelectedCheck selected={option.kind === currentKind} />
              </td>
              <td className="text-left col-sm-2">
                {option.packageSetEntry && option.packageSetEntry.fixedCost > 0 ? (
                  <Currency value={option.packageSetEntry.fixedCost} precision="automatic" />
                ) : (
                  'Included'
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};
